import { useEffect } from "react";
import useSWR from "swr";

export default function useToken() {
  const {
    data: token,
    mutate,
    isValidating,
  } = useSWR("/api/user", (apiURL: string) =>
    fetch(apiURL).then((res) => res.json())
  );

  useEffect(() => {
    if (!token) return;
  }, [token]);

  return { token, isLoading: isValidating };
}
